import React, { useState } from 'react';
import { Button, HStack, Switch, useDisclosure } from '@chakra-ui/react';
import ModalUpdatePostventa from './ModalActualizarPostventa';
import ModalMostrarTitulares from './ModalMostrarTitulares';
import CambiarEstatusActivo from './CambiarEstatusActivos';
import { useTranslation } from 'react-i18next';

export default function Tabla({ datos, loadPostventas, postVentasActivos }) {

  const { t } = useTranslation();

  const {
    isOpen: isOpenModalUpdatePostVenta,
    onOpen: onOpenModalUpdatePostVenta,
    onClose: onCloseModalUpdatePostVenta,
  } = useDisclosure();
  const {
    isOpen: isOpenModalTitulares,
    onOpen: onOpenModalTitulares,
    onClose: onCloseModalTitulares,
  } = useDisclosure();
  const {
    isOpen: isOpenDialogConfirm,
    onOpen: onOpenDialogConfirm,
    onClose: onCloseDialogConfirm,
  } = useDisclosure();

  const [selectedPostventa, setSelectedPostventa] = useState({});
  const [titulares, setTitulares] = useState([]);

  //usado para cambiar el estatus
  const [statusToChange, setStatusToChange] = useState(false);

  const displayTitulares = (postventa) => {
    setSelectedPostventa(postventa);
    setTitulares(postventa.titulares);
    onOpenModalTitulares();
  };

  const selectPostventa = (postventa) => {
    setSelectedPostventa(postventa);
    onOpenModalUpdatePostVenta();
  };

  //usado para cambiar el estatus
  const handleChangeStatus = (postventa) => {
    setSelectedPostventa(postventa);
    setStatusToChange(!postventa.activo);
    onOpenDialogConfirm();
  };

  return (
    <div className="table-responsive postV-table">
      <table className="table">
        <thead>
          <tr>
          <th className="col-sm px-sm-2">{t('NAME')}</th>
          <th className="col-sm px-sm-2">{t('LAST_NAME')}</th>
          <th className="col-sm px-sm-2">{t('EMAIL')}</th>
          <th className="col-sm px-sm-2">{t('PHONE_NUMBER')}</th>
          <th className="col-sm px-sm-2">{t('STATUS')}</th>
          <th className="col-sm px-sm-2">{t('OPTIONS')}</th>
          </tr>
        </thead>
        <tbody>
          {datos.map((postVenta) => (
            <tr key={`pv-${postVenta.id}`}>
              <td>{postVenta.nombre}</td>
              <td>{postVenta.apellidos}</td>
              <td>{postVenta.correo}</td>
              <td>{postVenta.numero}</td>
              <td onClick={() => handleChangeStatus(postVenta)}>
                <Switch isChecked={postVenta.activo} />{' '}
                {postVenta.activo ? t('ACTIVE') : t('INACTIVE')}
              </td>
              <td>
                <HStack spacing={4}>
                  <Button
                    colorScheme="telegram"
                    onClick={() => displayTitulares(postVenta)}
                  >
                    {t('VIEW_HOLDERS')}: {postVenta.titulares.length}
                  </Button>
                  <Button
                    colorScheme="linkedin"
                    onClick={() => selectPostventa(postVenta)}
                  >
                    {t('EDIT')}
                  </Button>
                </HStack>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ModalUpdatePostventa
        postVenta={selectedPostventa}
        isOpen={isOpenModalUpdatePostVenta}
        onClose={onCloseModalUpdatePostVenta}
        loadPostventas={loadPostventas}
      />
      <ModalMostrarTitulares
        postventa={selectedPostventa}
        titulares={titulares}
        isOpen={isOpenModalTitulares}
        onClose={onCloseModalTitulares}
      />
      <CambiarEstatusActivo
        loadPostventas={loadPostventas}
        postVentasActivos={postVentasActivos}
        selectedPostventa={selectedPostventa}
        statusToChange={statusToChange}
        isOpenDialogConfirm={isOpenDialogConfirm}
        onCloseDialogConfirm={onCloseDialogConfirm}
      />
    </div>
  );
}
